module.exports = __webpack_public_path__ + "components/country-flag/static/au-1a9720ee8e4adda835ecd7c68ba9ec51.svg";